import React, { useState, useEffect, useRef, useMemo } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import { HalfState } from '../../models/enums/HalfState';

const ScoringDetails = (props) => {

    const { fixtureDetails, inputItemList, currentClipNumber, currentHalfState } = props;

    const halfStateText = useMemo(() => {
        switch (currentHalfState) {
            case HalfState.BeforeFirstHalf:
                return "Prematch";
            case HalfState.FirstHalf:
                return "1";
            case HalfState.DuringHalfTime:
                return "HT break";
            case HalfState.SecondHalf:
                return "2";
            case HalfState.AfterSecondHalf:
                return "After FT";
            default:
                return "";
        }
    }, [currentHalfState]);
    return <>
        {fixtureDetails &&
            <div className="mt-2">
                {fixtureDetails.isForTraining &&
                    <Row>
                        <Col>
                            <h4>
                                Training Name: {fixtureDetails.trainingName}
                            </h4>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col>
                        <h6>
                            Bureau Id:  {fixtureDetails.fixtureId}
                        </h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h6>
                            Fixture: {fixtureDetails.homeTeam?.name} vs {fixtureDetails.awayTeam?.name}
                        </h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h6>
                            Date:  {fixtureDetails.dateString} {fixtureDetails.kickoffTime}
                        </h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h6>
                            <span className="">Home: {fixtureDetails.homeTeamScore}</span>
                            <span className="ml-1">Away: {fixtureDetails.awayTeamScore}</span>
                            <span className="ml-1">Half: {halfStateText}</span>
                        </h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h6>
                            <span className="">Clip: {currentClipNumber ? currentClipNumber : 'Outside clip'}</span>
                        </h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h6>
                            <span className="">Number Of Inputs: {inputItemList ? inputItemList.length : 0}</span>
                        </h6>
                    </Col>
                </Row>
            </div>
        }
    </>;

}

export default ScoringDetails;
